function helperGetDateMonth (date) {
  return date.getMonth()
}

module.exports = helperGetDateMonth
